import React from "react";
import { Controller } from "react-hook-form";
import { Form } from "react-bootstrap";
import CountryCodeSelectOptions from "./CountryCodeSelect";

function FormField({
  label,
  name,
  control,
  errors,
  rules,
  element_type,
  defaultValue,
  ...props
}) {
  return (
    <Form.Group className="mb-2">
      <Form.FloatingLabel
        label={
          <>
            {"required" in rules ? (
              <p>
                {label} <b className="text-danger">*</b>
              </p>
            ) : (
              <p>{label}</p>
            )}
          </>
        }
      >
        <Controller
          render={({ field }) => (
            <>
              {element_type === "control" && (
                <Form.Control
                  {...field}
                  onChange={(e) => field.onChange(e.target.value)}
                  placeholder={label}
                  isInvalid={!!errors[field.name]}
                  {...props}
                />
              )}
              {element_type === "select_country" && (
                <Form.Select
                  {...field}
                  onChange={(e) => field.onChange(e.target.value)}
                  placeholder={label}
                  htmlSize={1}
                  isInvalid={!!errors[field.name]}
                  {...props}
                >
                  <CountryCodeSelectOptions />
                </Form.Select>
              )}
              <Form.Control.Feedback type="invalid">
                {errors[field.name]?.message}
              </Form.Control.Feedback>
            </>
          )}
          name={name}
          control={control}
          defaultValue={defaultValue}
          rules={rules}
        />
      </Form.FloatingLabel>
    </Form.Group>
  );
}

FormField.defaultProps = {
  element_type: "control",
  defaultValue: "",
  rules: {},
};

export default FormField;
